import { render, staticRenderFns } from "./IdeaScoreTest.vue?vue&type=template&id=52053e61&scoped=true"
import script from "./IdeaScoreTest.vue?vue&type=script&lang=js"
export * from "./IdeaScoreTest.vue?vue&type=script&lang=js"
import style0 from "./IdeaScoreTest.vue?vue&type=style&index=0&id=52053e61&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52053e61",
  null
  
)

export default component.exports